module.exports = __webpack_public_path__ + "img/Stemness-PRCA_10X_ACC.633ed270.png";